"use client";
import React from "react";
import Link from "next/link";
import Icon from "@/components/ui/AppIcon";

const packages = [
  {
    name: "Başlangıç",
    icon: "RocketLaunchIcon" as const,
    color: "text-secondary",
    bg: "bg-secondary/10",
    popular: false,
    features: ["Rehberde listeleme", "Temel profil sayfası", "Müşteri yorumları", "Aylık rapor"],
  },
  {
    name: "Profesyonel",
    icon: "SparklesIcon" as const,
    color: "text-primary",
    bg: "bg-primary/10",
    popular: true,
    features: ["Sosyal medya paylaşımı", "Rehberde öne çıkarma", "Kampanya duyurusu", "Haftalık rapor"],
  },
  {
    name: "Premium",
    icon: "TrophyIcon" as const,
    color: "text-accent",
    bg: "bg-accent/10",
    popular: false,
    features: ["Reel/video üretimi", "Tüm sosyal medya", "Öncelikli destek", "Gerçek zamanlı rapor"],
  },
];

export default function AdPackagesTeaser() {
  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <h2 className="text-section-title text-foreground mb-3">
            İşletmeni Konya&apos;nın Gündemine Taşı
          </h2>
          <p className="text-muted-foreground text-sm max-w-lg mx-auto">
            Firmana özel tanıtım platformu. Hedef kitlenize doğrudan ulaşın.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10">
          {packages.map((pkg) => (
            <div
              key={pkg.name}
              className={`relative rounded-2xl p-6 border-2 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl ${
                pkg.popular
                  ? "border-primary bg-primary/5" :"border-border bg-card"
              }`}
            >
              {pkg.popular && (
                <div className="absolute -top-3.5 left-1/2 -translate-x-1/2">
                  <span className="px-4 py-1.5 rounded-full text-xs font-bold text-white gradient-primary shadow-lg whitespace-nowrap">
                    En Çok Tercih Edilen
                  </span>
                </div>
              )}
              <div className={`w-12 h-12 rounded-2xl ${pkg.bg} flex items-center justify-center mb-5`}>
                <Icon name={pkg.icon} size={24} className={pkg.color} />
              </div>
              <h3 className="font-bold text-lg text-foreground mb-4">{pkg.name}</h3>
              <ul className="space-y-2.5 mb-6">
                {pkg.features.map((f) => (
                  <li key={f} className="flex items-center gap-2.5 text-sm text-muted-foreground">
                    <Icon name="CheckCircleIcon" size={16} className="text-secondary shrink-0" variant="solid" />
                    {f}
                  </li>
                ))}
              </ul>
              <p className="text-xs font-semibold text-muted-foreground text-center">İletişime Geçin</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link href="/advertise" className="btn-primary text-base px-8 py-4">
            <Icon name="MegaphoneIcon" size={20} />
            Tüm Paketleri İncele
          </Link>
        </div>
      </div>
    </section>
  );
}